import React, { useEffect, useState } from "react";
import img from "./assets/ll.png";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../Admin/Config/Config";
import { getAuth } from "firebase/auth";
import { app } from "../Admin/Config/Config";
import { getFunctions, httpsCallable } from "firebase/functions";
import { countryCodes } from "./assets/Countrycodes";
export default function RegPopUp({ toogle, user }) {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [userdetails, setUserDetails] = useState({
    mobile: user?.mobile ?? "",
    district: user?.district ?? "",
    countryCode: "91",
    email: user?.email ?? "",
  });

  useEffect(() => {
    setIsOpen(toogle);
  }, [toogle]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    const auth = getAuth();
    const uid = auth.currentUser.uid;
    const number = "+" + userdetails.countryCode.trim() + userdetails.mobile.trim();
    setLoading(true);
    await updateDoc(doc(db, "users", uid), {
      mobile: number,
      district: userdetails.district,
      email: userdetails.email,
      study_stream: "Jaffers English",
    });

    // Add Firebase function call
    const functions = getFunctions(app, "asia-south1");
    const updateProfileCall = httpsCallable(functions, "checkoldstudents");
    try {
      await updateProfileCall({
        uid: uid
      });
    } catch (err) {
      console.error("Error calling function:", err.message);
    }

    setIsOpen(false);
    setLoading(false);
  };

  const handleOverlayClick = () => {
    setShowToast(true);
    const timer = setTimeout(() => {
      setShowToast(false);
    }, 3000);
    return () => clearTimeout(timer);
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in"
          onClick={handleOverlayClick}
        >
          {/* Modern Toast Notification */}
          {showToast && (
            <div className="fixed top-5 left-1/2 transform -translate-x-1/2 z-50">
              <div className="bg-white shadow-xl rounded-lg p-4 flex items-center space-x-2 animate-fade-in-down">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-emerald-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
                <span className="text-gray-800 font-medium">
                  Please complete your profile to continue
                </span>
              </div>
            </div>
          )}

          <div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden relative animate-scale-in border border-gray-100"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-8">
              <div className="border-b border-gray-100 pb-6 mb-6">
                <img
                  src={img}
                  alt="Company Logo"
                  className="mx-auto h-20 mb-6 object-contain transform hover:scale-105 transition-transform duration-300"
                />
                <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">
                  Complete Your Profile
                </h2>
                <p className="text-gray-500 text-center">
                  We need a few more details to personalize your experience
                </p>
              </div>

              <form onSubmit={handleUpdate} className="space-y-6">
                {user && !user.mobile ? (
                  <div className="flex gap-4">
                    <div className="w-28">
                      <label className="block text-xs font-semibold text-gray-600 mb-2 tracking-wide text-left">
                        Country Code
                      </label>
                      <div className="relative group flex">
                        <div className="flex items-center justify-center px-3 py-2.5 border border-gray-200 rounded-l-lg bg-gray-50 border-r-0">
                          <span className="text-gray-600 font-semibold">+</span>
                        </div>
                        <select
                          value={userdetails.countryCode}
                          className="w-full pl-3 pr-3 py-2.5 border border-gray-200 rounded-r-lg focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all duration-200 bg-white text-gray-700 font-medium shadow-sm hover:border-gray-300"
                          onChange={(e) =>
                            setUserDetails({
                              ...userdetails,
                              countryCode: e.target.value,
                            })
                          }
                        >
                          {countryCodes.map((country) => (
                            <option key={country.name} value={country.code}>
                              {country.code}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="flex-1">
                      <label className="block text-xs font-semibold text-gray-600 mb-2 tracking-wide text-left">
                        Mobile Number
                      </label>
                      <input
                        required
                        type="tel"
                        // pattern="[0-9]{10}"
                        onChange={(e) =>
                          setUserDetails({
                            ...userdetails,
                            mobile: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all duration-200 bg-white text-gray-700 shadow-sm hover:border-gray-300"
                        placeholder="Enter your mobile number"
                      />
                    </div>
                  </div>
                ) : null}
                <div>
                  {user && !user.email ? (
                    <div className="flex-1">
                      <label className="block text-xs font-semibold text-gray-600 mb-2 tracking-wide text-left">
                        Email
                      </label>
                      <input
                        required
                        type="email"
                        // pattern="[0-9]{10}"
                        onChange={(e) =>
                          setUserDetails({
                            ...userdetails,
                            email: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all duration-200 bg-white text-gray-700 shadow-sm hover:border-gray-300"
                        placeholder="Enter your email"
                      />
                    </div>
                  ) : null}
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-2 tracking-wide text-left">
                    Select District
                  </label>
                  <select
                    onChange={(e) =>
                      setUserDetails({
                        ...userdetails,
                        district: e.target.value,
                      })
                    }
                    required
                    className="w-full px-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all duration-200 bg-white text-gray-700 shadow-sm hover:border-gray-300 appearance-none bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMxMEI5ODUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cG9seWxpbmUgcG9pbnRzPSI2IDkgMTIgMTUgMTggOSI+PC9wb2x5bGluZT48L3N2Zz4=')] bg-no-repeat bg-[right_1rem_center] bg-[length:1.5em]"
                  >
                    <option value="">Select your district</option>
                    <option value="Wayanad">Wayanad</option>
                    <option value="Calicut">Calicut</option>
                    <option value="Kannur">Kannur</option>
                    <option value="Kasargod">Kasargod</option>
                    <option value="Malappuram">Malappuram</option>
                    <option value="Thrissur">Thrissur</option>
                    <option value="Palakkad">Palakkad</option>
                    <option value="Ernakulam">Ernakulam</option>
                    <option value="Idukki">Idukki</option>
                    <option value="Kottayam">Kottayam</option>
                    <option value="Pathanamthitta">Pathanamthitta</option>
                    <option value="Alappuzha">Alappuzha</option>
                    <option value="Kollam">Kollam</option>
                    <option value="Thiruvananthapuram">
                      Thiruvananthapuram
                    </option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                <button
                  disabled={loading}
                  type="submit"
                  className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 text-white font-medium py-3 rounded-lg hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-70 disabled:cursor-not-allowed transform hover:scale-[1.02] active:scale-[0.98] border border-emerald-700/20"
                >
                  {loading ? (
                    <span className="flex items-center justify-center">
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Processing...
                    </span>
                  ) : (
                    "Complete Profile"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Add this to your CSS or Tailwind config */}
      <style jsx>{`
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fade-in-down {
          animation: fadeInDown 0.3s ease-out forwards;
        }
        .animate-fade-in {
          animation: fadeIn 0.3s ease-out forwards;
        }
        .animate-scale-in {
          animation: scaleIn 0.3s ease-out forwards;
        }
      `}</style>
    </>
  );
}